import {ValueObject} from '@s-ui/domain'

import {LocationEntity} from '../Entities/LocationEntity.js'
import {ProvincesListLocationValueObject} from './ProvincesListLocationValueObject.js'

export class ProvincesLocationValueObject extends ValueObject {
  #all
  #main

  constructor({all, main}) {
    super()
    this.#all = all
    this.#main = main
  }

  static createFromListingApi({mainProvince, mainProvinceId, provinceIds}) {
    return new ProvincesLocationValueObject({
      all: ProvincesListLocationValueObject.createFromListingApi({provinceIds}),
      main: LocationEntity.createFromLiterals({id: mainProvinceId, name: mainProvince})
    })
  }

  get all() {
    return this.#all.value
  }

  get main() {
    return this.#main.value
  }

  hasMultipleProvinces() {
    return this.#all.length > 1
  }

  get value() {
    return {
      all: this.all,
      main: this.main
    }
  }
}
